import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import CopyToClipboardIcon from "@mui/icons-material/ContentCopy";
import { RaRecord, useRecordContext } from "react-admin";

export function CopyVogelIdIntoClipboardMenuItem(props: { record?: RaRecord; closeMenu: () => void }) {
  const { closeMenu } = props;
  const record = useRecordContext(props);
  if (!record?.vogelId) {
    return null;
  }
  return (
    <MenuItem
      onClick={async () => {
        closeMenu();
        await navigator.clipboard.writeText(record.vogelId);
        showSuccessToast("Vogel ID in die Zwischenablage kopiert.");
      }}
    >
      <ListItemIcon>
        <CopyToClipboardIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>Kopiere Vogel ID in die Zwischenablage</ListItemText>
    </MenuItem>
  );
}
